<template>
  <vertical-space :top="marginTop" :bottom="marginBottom" :backgroundColor="bgColor">
    <div class="single-video" :class="{'fullpage': fullpage}">
      <scroll-speed :speed="1.1">
        <div slot-scope="{}" class="parallax" :class="{maxWidth: 'max-width'}">
          <video class="single-video__wrapper lazy" :class="{shadow: 'shadow'}" loop autoplay muted>
            <source
              :key="source.url"
              v-for="source in sources"
              :src="source.url"
              :type="'video/' + source.filetype"
            />
          </video>
        </div>
      </scroll-speed>
    </div>
  </vertical-space>
</template>

<script>
import { mapState } from "vuex";
import LazyLoad from "vanilla-lazyload";
import scrollSpeed from "@/components/scroll-speed.vue";
import verticalSpace from "@/components/vertical-space.vue";

export default {
  name: "CaseViewSingleImage",
  components: { scrollSpeed, verticalSpace },
  props: {
    bgColor: String,
    shadow: Boolean,
    sources: Array,
    fullpage: { type: Boolean, default: false },
    maxWidth: { type: Boolean, default: false },

    marginTop: { type: Number, default: 0 },
    marginBottom: { type: Number, default: 0 }
  }
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

.single-video {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: $margin1-2;
  @media screen and (min-width: 769px) {
    padding: $margin1-2 $margin1-1;
  }
  @media screen and (min-width: 1025px) {
    padding: $margin1-1 $margin2-1;
  }

  .parallax {
    max-width: 100%;
    height: 100%;
    display: flex;
    align-items: center;

    &.max-width {
      max-width: 1560px;
      padding: $margin1-1 0;
    }
  }

  &.fullpage {
    padding: 0;
  }

  &.vertical-padding {
    padding: $margin1-1 0;
    @media screen and (min-width: 769px) {
      padding: $margin1-2;
    }
  }

  &__wrapper {
    margin: 0 auto;
    height: auto;
    max-height: 80vh;

    pointer-events: none;
  }

  .shadow {
    box-shadow: 0 2em 4em rgba(0, 0, 0, 0.15);
  }

  video {
    max-width: 100%;
  }
}
</style>
